// extracted by mini-css-extract-plugin
export default {"wrapper":"BrandHomeMenu_wrapper__p1+cj"};